
import { useTranslation } from "react-i18next";

interface ReferralInfoProps {
  hasReferral: boolean;
}

export const ReferralInfo = ({ hasReferral }: ReferralInfoProps) => {
  const { t } = useTranslation('auth');
  
  if (!hasReferral) return null;

  return (
    <div className="w-full max-w-md bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <p className="text-center text-blue-800">
        {t('referral.youWereInvited')}
      </p>
    </div>
  );
};
